import mixins from './../_mixins-missmatch-monitor';

export default {
    name: 'TabKeyProductDetails',
    mixins: [mixins],
    props: {
        item: {
            type: Object,
            required: true
        }
    },

    mounted() {
        this.getAccountsKeyProductMismatch();
    },

    data() {
        return {
            items: []
        };
    },

    methods: {
        getAccountsKeyProductMismatch() {
            this.$accountsService
                .accountsKeyProductMismatch(this.item.key_product, {})
                .then(response => {
                    this.items = response.data.accounts_positions_comparisons;
                })
                .catch(error => console.error(error));
        }
    },

    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            const filteredData = this.items.filter(item => 
                item.has_mismatch && 
                item.comparisons.some(comp => 
                    comp.key_product === this.item.key_product && comp.has_mismatch
                )
            );
            return filteredData.map(x => {
                return {
                    uuid: x.account.uuid,
                    status: x.has_mismatch ? 'failed' : 'success',
                    account: x.account.id_object,
                    holders: x.account.holders,
                    show_details: true,
                    comparisons: x.comparisons
                };
            });
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return ['account', 'holders', 'show_details'];
        }
    }
};
